import React from 'react';
import { SlideDown } from 'react-slidedown';
import EmployersTable from '../EmployersTable';
import Skeleton from '@material-ui/lab/Skeleton';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import {
  SecondarySpanMedium,
  PrimarySpanMedium,
  PrimaryButton,
  LightPrimaryButton,
} from 'atoms/StyledComponents';
import './style.scss';
import { FormattingUtils } from "utils/index";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    link_hover: {
      '&:hover': {
        textDecoration: 'underline !important',
        // color: terciaryColor,
        cursor: 'pointer',
      },
    },
  }),
);

interface Props {
  className?: any;
  location: any;
  total_commissions: number;
  total_premiums: number;
  num_clients: number;
  showProducers?: any;
  seeContacts?: any;
  employers?: any[];
  brokerId?: string;
  onClickEmployer?: any;
  onClickTopBroker?: any;
  open: boolean;
  toggleOpen: () => void;
  selectedOfficeEmployer: string;
  selectedOfficeLocation: string;
}

const BrokerLocationCard = ({
  className,
  location,
  total_commissions,
  total_premiums,
  num_clients,
  employers,
  brokerId,
  showProducers,
  seeContacts,
  onClickEmployer,
  onClickTopBroker,
  open,
  toggleOpen,
  selectedOfficeEmployer,
  selectedOfficeLocation
}: Props) => {
  const classes = useStyles();

  // const brokerPage = useSelector(selectBrokerPage);

  const autoScrollRequired = (() => {
    let required = false;

    required =
      location === selectedOfficeLocation &&
      (employers || []).some(
        (employer: any) => employer.employer_master_id === selectedOfficeEmployer,
      );

    return required;
  })();

  const generateId = () =>
    `broker_location_card_${location
      ?.replace(/[^A-Z0-9]/gi, '_')
      .toLowerCase()}`;

  return (
    <div id={generateId()} className="dev-card">
      <div className="c-header">
        <div className="">
          <PrimarySpanMedium
            className={classes.link_hover}
            onClick={toggleOpen}
          >
            {location ? (
              location === `null, null` ? (
                `[Office Not Specified]`
              ) : (
                location
              )
            ) : (
              <Skeleton variant="text" width={150} />
            )}
          </PrimarySpanMedium>
          <SecondarySpanMedium style={{ fontWeight: 700, marginTop: '15px' }}>
            {total_commissions ? (
              `$${FormattingUtils.formatNumberAbbrev(
                total_commissions,
              )} Commissions Reported`
            ) : (
              <Skeleton variant="text" width={200} />
            )}
          </SecondarySpanMedium>
          <SecondarySpanMedium style={{ fontWeight: 700, marginTop: '15px' }}>
            {total_premiums ? (
              `$${FormattingUtils.formatNumberAbbrev(
                total_premiums,
              )} Carrier Premiums`
            ) : (
              <Skeleton variant="text" width={200} />
            )}
          </SecondarySpanMedium>
          <SecondarySpanMedium style={{ marginTop: '15px' }}>
            {num_clients ? (
              `${num_clients} Clients`
            ) : (
              <Skeleton variant="text" width={125} />
            )}
          </SecondarySpanMedium>
        </div>
        <div className="c-actions">
          <LightPrimaryButton
            onClick={toggleOpen}
            style={{ marginRight: '10px' }}
          >
            See Clients
          </LightPrimaryButton>
          <PrimaryButton
            onClick={seeContacts}
            style={{ marginRight: '10px' }}
          >
            See Contacts
          </PrimaryButton>
        </div>
      </div>
      <div className="c-content">
        <SlideDown className={'my-dropdown-slidedown'}>
          {open ? (
            <EmployersTable
              className="employers-table"
              autoScrollRequired={autoScrollRequired}
              scrollToRow={selectedOfficeEmployer}
              employers={employers}
              onClickEmployer={onClickEmployer}
              onClickTopBroker={onClickTopBroker}
              brokerId={brokerId}
            />
          ) : null}
        </SlideDown>
      </div>
    </div>
  );
};

export default BrokerLocationCard;
